import {
	NullableString,
} from "@/customTypes/CommonTypes";
export const REDUCER_NAME = "authSlice";

export type GenericNullable<T> = T | null;

export interface iUserDetailsResponse{
	name:string,
	email:string,
	mobile:string,
	address:NullableString,
	profilePicture:NullableString
}

export interface iUserLoginResponse{
	id:string,
	user: iUserDetailsResponse,
	token: NullableString,
}

export interface iProductResponse {
	title: string,
	sku: string;
	product_type: string;
	category_id: string;
	description: string;
	product_image: string;
	price: number;
	cost_price: number;
	sale_price: number;
	retail_price: number;
	inventory_status: string;
	availability: string;
	global_trade_item_number: string;
	manufacturer_part_number: string;
	brand_name: string;
	product_upc_ean: string;
	custom_field_name: string;
	custom_field_value: string;
	is_shipping_free: boolean;
	page_title: string;
	meta_keywords: string;
	meta_description: string;
	product_url: string;
	delivery_event_name: string;
	// variants: Array<{ variant_name: string; variant_value: string }>;
	shipping_details: Array<{ location_name: string; shipping_charge: number }>;
	taxOptions: string;
	// international_Shipping:number;
}


export interface iUserState {
	isLoading: boolean;
	user: iUserProfileDetails | null;
	token: NullableString;
	isAuthenticated: boolean;
	errorMessage: NullableString;
  }

export interface iUserRegisterBody{
	firstName:string,
	lastName?:NullableString
	email:string,
	password:string,
	confirmPassword:string
}

export interface iChangePassword{
	currentPassword:string,
	newPassword:string,
	confirmedPassword:string
}

export interface iUserProfile {
	id: string;
	user: iUserProfileDetails;
  }

export interface iUserProfileDetails {
	id?:string;
	firstName?: string;
	lastName?: string;
	email?: string;
	mobile?: string;
	address?: string | null;
	role?: string;
	profilePicture?: string | null;
	username?: string | null;
	website?: string | null;
	description?: string | null;
	country?: string | null;
	timezone?: string | null;
	bio?: string | null;
	portfolios?: string | null;
	kycStatus?: string | null;
	modules?:Array<string>|null;
	balance?:number;
	refferalCode?:string;
	businessType:string;
	deliveryType:string[];
	deliveryLocations:string[];
	deliveryState:string[];
	deliveryCountry:string[];
	serviceCategory:Array<string>;
	vendorId:string;
	GSTNumber:string;
	wholesaler_id?: string | null;
	onboardingComplete?: boolean;

}
  